import React from 'react';

import TypeLabel from '../TypeLabel';

const Heading = ({ contentLeft, contentRight, typeLabel, large = false, onClick }) => (
  <div
    className={`heading size-${large ? 'large' : 'small'}`}
    onClick={onClick}
    role="heading"
    onKeyDown={(e) => {
      if ((e.key === 'Enter' || e.key === ' ') && onClick) {
        e.preventDefault();
        onClick(e);
      }
    }}
    tabIndex={0}
  >
    <div>
      {typeof typeLabel !== 'undefined' && <TypeLabel type={typeLabel} />}
      {contentLeft}
    </div>
    <div>{contentRight}</div>
  </div>
);

export default Heading;
